module.exports = __webpack_public_path__ + "media/images/icon-zoom-abb0c15b.png";